const state = () => ({
  selectList: [], // 课程下拉列表
});

const mutations = {
  setSelectList(state, data) {
    state.selectList = data;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
